import { login, loginByCode, register, refreshToken } from '@/api/auth'
import { getUserProfile } from '@/api/users'

const state = {
  accessToken: localStorage.getItem('accessToken') || '',
  refreshToken: localStorage.getItem('refreshToken') || '',
  userInfo: JSON.parse(localStorage.getItem('userInfo') || 'null'),
  isLoggedIn: !!localStorage.getItem('accessToken')
}

const mutations = {
  SET_TOKEN(state, { accessToken, refreshToken }) {
    console.log('SET_TOKEN - 接收到的 accessToken:', accessToken)
    console.log('SET_TOKEN - 接收到的 refreshToken:', refreshToken)
    
    state.accessToken = accessToken
    state.refreshToken = refreshToken
    state.isLoggedIn = !!accessToken
    
    localStorage.setItem('accessToken', accessToken)
    localStorage.setItem('isLoggedIn', 'true')
    if (refreshToken) {
      localStorage.setItem('refreshToken', refreshToken)
    }
    
    console.log('SET_TOKEN - localStorage 已保存')
    console.log('SET_TOKEN - 验证 localStorage:', localStorage.getItem('accessToken'))
  },
  
  SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo
    localStorage.setItem('userInfo', JSON.stringify(userInfo))
  },
  
  LOGOUT(state) {
    state.accessToken = ''
    state.refreshToken = ''
    state.userInfo = null
    state.isLoggedIn = false
    
    localStorage.removeItem('accessToken')
    localStorage.removeItem('refreshToken')
    localStorage.removeItem('userInfo')
    localStorage.removeItem('isLoggedIn')
  }
}

const actions = {
  // 登录
  async login({ commit }, loginForm) {
    try {
      const response = await login(loginForm)
      console.log('登录响应完整数据:', response)
      
      // 后端返回格式: { success: true, data: { userId, token, refreshToken, userInfo: { nickname, isVerified } } }
      const { userId, token, refreshToken, userInfo } = response.data
      
      console.log('提取的 Token:', token)
      console.log('提取的用户信息:', userInfo)
      
      if (!token) {
        throw new Error('登录响应中没有 token')
      }
      
      // 保存 token (注意: 后端字段是 token 不是 accessToken)
      commit('SET_TOKEN', { accessToken: token, refreshToken })
      // 合并 userId 和 userInfo
      commit('SET_USER_INFO', { 
        userId, 
        nickname: userInfo?.nickname,
        isVerified: userInfo?.isVerified
      })
      
      return response
    } catch (error) {
      console.error('登录失败:', error)
      throw error
    }
  },
  
  // 验证码登录
  async loginByCode({ commit }, loginForm) {
    try {
      const response = await loginByCode(loginForm)
      console.log('验证码登录响应:', response)
      
      const { userId, token, refreshToken, userInfo } = response.data
      
      if (!token) {
        throw new Error('登录响应中没有 token')
      }
      
      commit('SET_TOKEN', { accessToken: token, refreshToken })
      commit('SET_USER_INFO', { 
        userId, 
        nickname: userInfo?.nickname,
        isVerified: userInfo?.isVerified
      })
      
      return response
    } catch (error) {
      console.error('验证码登录失败:', error)
      throw error
    }
  },
  
  // 注册
  async register({ commit }, registerForm) {
    try {
      const response = await register(registerForm)
      console.log('注册响应:', response)
      
      const { userId, token, refreshToken, userInfo } = response.data
      
      if (!token) {
        throw new Error('注册响应中没有 token')
      }
      
      commit('SET_TOKEN', { accessToken: token, refreshToken })
      commit('SET_USER_INFO', { 
        userId, 
        nickname: userInfo?.nickname,
        isVerified: userInfo?.isVerified
      })
      
      return response
    } catch (error) {
      console.error('注册失败:', error)
      throw error
    }
  },
  
  // 刷新Token
  async refreshToken({ commit, state }) {
    try {
      const response = await refreshToken({ refreshToken: state.refreshToken })
      const { accessToken, refreshToken: newRefreshToken } = response.data
      
      commit('SET_TOKEN', { accessToken, refreshToken: newRefreshToken })
      
      return response
    } catch (error) {
      console.error('刷新Token失败:', error)
      commit('LOGOUT')
      throw error
    }
  },
  
  // 获取用户信息
  async getUserInfo({ commit }) {
    try {
      const response = await getUserProfile()
      commit('SET_USER_INFO', response.data)
      return response
    } catch (error) {
      console.error('获取用户信息失败:', error)
      throw error
    }
  },
  
  // 登出
  logout({ commit }) {
    commit('LOGOUT')
  }
}

const getters = {
  isLoggedIn: state => state.isLoggedIn,
  userInfo: state => state.userInfo,
  userId: state => state.userInfo?.userId,
  nickname: state => state.userInfo?.nickname,
  avatar: state => state.userInfo?.avatar,
  isVerified: state => state.userInfo?.isVerified
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
